import { AlertCircle, CheckCircle2, Loader2, Lock } from "lucide-react";
import { useLang } from "@/i18n";

const STATUS_STYLE = {
  queued: "border-vox-line text-vox-muted",
  transcribing: "border-vox-accent/40 text-vox-bright",
  summarizing: "border-vox-amber/40 text-vox-amber",
  generating_docx: "border-vox-amber/40 text-vox-amber",
  done: "border-emerald-500/40 text-emerald-300",
  error: "border-vox-rec/40 text-[#ff9b9e]",
};

export function StatusBadge({ status }) {
  const { t } = useLang();
  const cls = STATUS_STYLE[status] || STATUS_STYLE.queued;
  const busy = !["done", "error"].includes(status);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider ${cls}`} data-testid={`ai-processing-status-badge`} data-status={status}>
      {status === "done" ? <CheckCircle2 size={12} /> : status === "error" ? <AlertCircle size={12} /> : busy ? <Loader2 size={12} className="animate-spin" /> : null}
      {t(`detail.status.${status}`, status)}
    </span>
  );
}

export function MeetingStatus({ status }) {
  const { t } = useLang();
  const map = {
    live: "border-emerald-500/40 text-emerald-300",
    scheduled: "border-vox-line text-vox-muted",
    ended: "border-vox-line text-vox-dim",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider ${map[status] || map.scheduled}`} data-testid="meeting-status-badge" data-status={status}>
      {status === "live" && <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-breathe" />}
      {t(`dashboard.${status}`, status)}
    </span>
  );
}

export function LockedAI({ compact = false }) {
  const { t } = useLang();
  return (
    <div className={`panel relative overflow-hidden border-vox-amber/25 ${compact ? "p-5" : "p-8"} text-center`} data-testid="locked-ai-feature-notice">
      <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full border border-vox-amber/30 bg-vox-amber/10 text-vox-amber">
        <Lock size={20} />
      </div>
      <div className="mono-label mb-2 !text-vox-amber">{t("locked.badge")}</div>
      <h3 className="text-lg font-semibold text-vox-text">{t("locked.title")}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-vox-muted">{t("locked.desc")}</p>
    </div>
  );
}

export const SectionLabel = ({ index, children }) => (
  <div className="mb-5 flex items-center gap-3">
    <span className="font-mono text-xs text-vox-accent">{index}</span>
    <span className="h-px w-8 bg-vox-line" />
    <span className="mono-label !text-vox-muted">{children}</span>
  </div>
);
